module.exports = __webpack_public_path__ + "static/media/ic_mastercard.a5b69e0a.svg";